import { initialValuesProject as initialValues } from '../../../../../../helpers/variablesInitialValues';
import * as types from '../types/projectType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	realState: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const projectReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_PROJECT:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_PROJECT:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_PROJECT:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_PROJECT:
			return {
				...state,
				search: payload
			};
			
		case types.REALSTATE_PROJECT:
			return {
				...state,
				realState: payload
			};
		
		case types.ARRAY_LIST_PROJECT:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_PROJECT:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_PROJECT:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_PROJECT:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_PROJECT:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_PROJECT:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_PROJECT:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_PROJECT:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default projectReducer;
